module.exports = __webpack_public_path__ + "static/img/ikonaFilm-ON.1ef3abe5.png";